import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function WarrantyInfo({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Warranty Information</b>
          </p>
          <p>
            Warranty information objects are used to capture warranty details
            for certain inventory items. They follows the structure below.
            <pre>
              <code>
                {`
{
  start: date string,
  end: date string,
  warranty: reference: warranty object
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
WarrantyInfo.propTypes = {
  type: PropTypes.string.isRequired
};
